import { render, staticRenderFns } from "./Dpt.vue?vue&type=template&id=1f0e78f7&scoped=true"
import script from "./Dpt.vue?vue&type=script&lang=js"
export * from "./Dpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e78f7",
  null
  
)

export default component.exports